/** Camada de referências náuticas (PostGIS) — /geo/v1/marine/layer. GeoJSON por bbox. */

export interface MarineFC {
  type: 'FeatureCollection';
  features: Array<{
    type: 'Feature';
    properties: { id: number; nome: string; tipo: string };
    geometry: { type: 'Point'; coordinates: [number, number] };
  }>;
}

export const marineApi = {
  layer: async (
    b: { minlon: number; minlat: number; maxlon: number; maxlat: number },
    types?: string,
    limit = 800,
  ): Promise<MarineFC> => {
    const p = new URLSearchParams({
      minlon: String(b.minlon), minlat: String(b.minlat),
      maxlon: String(b.maxlon), maxlat: String(b.maxlat), limit: String(limit),
    });
    if (types) p.set('types', types);
    const r = await fetch(`/geo/v1/marine/layer?${p.toString()}`, { credentials: 'include' });
    if (!r.ok) throw new Error(`marine/layer ${r.status}`);
    return r.json();
  },
};
